module.exports = __webpack_public_path__ + "c4d614753f5eb918a3d4f72aaef6cf2e.MP3";